module.exports = __webpack_public_path__ + "media/customizations/somersett/logo-adc667f1c41a9f748437db9022d4f24f.png";